import { useEffect, useState } from "react"

export function useLocalStorage<T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const item = globalThis.localStorage.getItem(key)
      return item === null ? initialValue : (JSON.parse(item) as T)
    } catch {
      return initialValue
    }
  })

  useEffect(() => {
    try {
      if (value != undefined)
        globalThis.localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      console.warn(`Error setting localStorage key "${key}":`, error)
    }
  }, [key, value]) // Include 'key' in the dependency array

  return [value, setValue]
}
